import { createAction } from 'redux-actions';
import { hasValue } from '../../../utils/utils';
import { LOCATION_CHANGE } from '../authentication/authentication.module';

const SET_NASU_ADDED_FUND_STEP = 'SET_NASU_ADDED_FUND_STEP';

export default function nasuAddedFund(
  state = {
    nasuAddedFundInitialized: false,
  },
  { payload, type }
) {
  switch (type) {
    case LOCATION_CHANGE: {
      if (state.nasuAddedFundInitialized) {
        return state;
      }
      const nasuAddedFundTypeCategory = /nasuAddedFund?=?([\w-]+)?/.exec(
        window.location.search
      );
      return {
        ...state,
        nasuAddedFundInitialized: hasValue(nasuAddedFundTypeCategory),
      };
    }
    case `${SET_NASU_ADDED_FUND_STEP}_FULFILLED`: {
      const newState = {
        ...state,
        showAllFundsStep: payload,
      };
      if (payload) {
        newState.nasuAddedFundAgreements = [];
      }
      return newState;
    }
    default:
      return state;
  }
}

export const setShowAllNasuFunds = (expanded) => {
  return (dispatch) => {
    const action = createAction(`${SET_NASU_ADDED_FUND_STEP}_FULFILLED`)(
      expanded
    );
    dispatch(action);
  };
};
